import { render, staticRenderFns } from "./InvitePanel.vue?vue&type=template&id=1a52ba66&scoped=true&"
import script from "./InvitePanel.vue?vue&type=script&lang=js&"
export * from "./InvitePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a52ba66",
  null
  
)

export default component.exports